export const basePrizeHub = 'prize-hub'
